export default "__VITE_ASSET__B0sqFs6U__"